import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card, Modal } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { GET_REVIEWS, SUBMIT_REVIEW } from '../graphql/operations';
import UspStrip from '../components/UspStrip';
import Footer from '../components/Footer';

// Importing banner assets
import banner1 from '../assets/banner/banner_1.jpg';
import banner2 from '../assets/banner/banner_2.jpg';
import banner3 from '../assets/banner/banner_3.jpg';
import banner4 from '../assets/banner/banner_4.jpg';
import banner5 from '../assets/banner/banner_5.jpg';
import banner6 from '../assets/banner/banner_6.jpg';
import banner7 from '../assets/banner/banner_7.jpg';
import banner8 from '../assets/banner/banner_8.jpg';

// Importing visiting card assets
import card1 from '../assets/visiting cards/card_1.jpg';
import card2 from '../assets/visiting cards/card_2.jpeg';

// Importing flyer assets
import flyer1 from '../assets/Flyers & Brochures/flyer1.jpeg';
import flyer2 from '../assets/Flyers & Brochures/flyer2.jpeg';
import flyer3 from '../assets/Flyers & Brochures/flyer3.jpeg';

// Importing wedding invite assets
import wedding1 from '../assets/wedding/a3 - 001 copy.jpg';
import wedding2 from '../assets/wedding/a3 - 002 copy.jpg';
import wedding3 from '../assets/wedding/cover - 001 copy 2.jpg';
import wedding4 from '../assets/wedding/wedding_card_4.jpeg';
import wedding5 from '../assets/wedding/wedding_card_5.jpeg';
import wedding6 from '../assets/wedding/wedding_card_6.jpeg';
import wedding7 from '../assets/wedding/wedding_card_7.jpeg';
import wedding8 from '../assets/wedding/wedding_card_8.jpeg';
import wedding9 from '../assets/wedding/wedding_card_9.jpeg';
import wedding10 from '../assets/wedding/wedding_card_10.jpeg';
import wedding11 from '../assets/wedding/wedding_card_11.jpeg';

// Importing sticker assets
import sticker1 from '../assets/stickers/10 X 3 Flex.jpg';
import sticker2 from '../assets/stickers/2 X 4 flex copy.jpg';
import sticker3 from '../assets/stickers/8 X 3 Flex.jpg';
import sticker4 from '../assets/stickers/sticker 7.jpeg';
import sticker5 from '../assets/stickers/sticker 8.jpeg';
import sticker6 from '../assets/stickers/sticker 9.jpeg';

interface PortfolioItem {
  img: string;
  title: string;
  category: string;
  client: string;
}

const portfolioCategories = ['All', 'Banners', 'Visiting Cards', 'Flyers', 'Wedding Invites', 'Stickers & Labels'];

const portfolioWorks: PortfolioItem[] = [
  { img: banner1, title: 'political flex banner', category: 'Banners', client: 'TVK' },
  { img: banner2, title: ' political flex banner_2', category: 'Banners', client: 'DMK 1' },
  { img: banner3, title: 'political flex banner_3', category: 'Banners', client: 'DMK' },
  { img: banner4, title: 'Political flex banner_4', category: 'Banners', client: 'DMK_2' },
  { img: banner5, title: 'Political flex banner_5', category: 'Banners', client: 'TVK_3' },
  { img: banner6, title: 'Political flex banner_6', category: 'Banners', client: 'TVK_4' },
  { img: banner7, title: 'COMMERCIAL SHOP BOARD', category: 'Banners', client: 'VELS_ENGINEERING' },
  { img: banner8, title: 'EVENT FLEX BANNER', category: 'Banners', client: 'KATHIREASAN_WEDDING' },
  { img: card1, title: 'BUSINESS CARD 1', category: 'Visiting Cards', client: 'card_1' },
  { img: card2, title: 'BUSINESS CARD 2', category: 'Visiting Cards', client: 'card_2' },
  { img: flyer1, title: 'FLYER 1', category: 'Flyers', client: 'flyer_1' },
  { img: flyer2, title: 'FLYER 2', category: 'Flyers', client: 'flyer_2' },
  { img: flyer3, title: 'FLYER 3', category: 'Flyers', client: 'flyer_3' },
  { img: wedding1, title: 'ELEGANT A3 WEDDING CARD 1', category: 'Wedding Invites', client: 'wedding_1' },
  { img: wedding2, title: 'ELEGANT A3 WEDDING CARD 2', category: 'Wedding Invites', client: 'wedding_2' },
  { img: wedding3, title: 'PREMIUM WEDDING COVER', category: 'Wedding Invites', client: 'wedding_3' },
  { img: wedding4, title: 'ROYAL WEDDING CARD 4', category: 'Wedding Invites', client: 'wedding_4' },
  { img: wedding5, title: 'ROYAL WEDDING CARD 5', category: 'Wedding Invites', client: 'wedding_5' },
  { img: wedding6, title: 'ROYAL WEDDING CARD 6', category: 'Wedding Invites', client: 'wedding_6' },
  { img: wedding7, title: 'ROYAL WEDDING CARD 7', category: 'Wedding Invites', client: 'wedding_7' },
  { img: wedding8, title: 'ROYAL WEDDING CARD 8', category: 'Wedding Invites', client: 'wedding_8' },
  { img: wedding9, title: 'ROYAL WEDDING CARD 9', category: 'Wedding Invites', client: 'wedding_9' },
  { img: wedding10, title: 'ROYAL WEDDING CARD 10', category: 'Wedding Invites', client: 'wedding_10' },
  { img: wedding11, title: 'ROYAL WEDDING CARD 11', category: 'Wedding Invites', client: 'wedding_11' },
  { img: sticker1, title: 'FLEX STICKER 10 X 3', category: 'Stickers & Labels', client: 'sticker_1' },
  { img: sticker2, title: 'FLEX STICKER 2 X 4', category: 'Stickers & Labels', client: 'sticker_2' },
  { img: sticker3, title: 'FLEX STICKER 8 X 3', category: 'Stickers & Labels', client: 'sticker_3' },
  { img: sticker4, title: 'PREMIUM GLOSSY STICKER 7', category: 'Stickers & Labels', client: 'sticker_7' },
  { img: sticker5, title: 'PREMIUM GLOSSY STICKER 8', category: 'Stickers & Labels', client: 'sticker_8' },
  { img: sticker6, title: 'PREMIUM GLOSSY STICKER 9', category: 'Stickers & Labels', client: 'sticker_9' },
];

// Reviews are now fetched live from the GraphQL backend

const mapCategoryToProductId = (category: string) => {
  switch (category) {
    case 'Visiting Cards':
      return 'visiting-cards';
    case 'Banners':
      return 'flex-banners';
    case 'Flyers':
      return 'flyers';
    case 'Wedding Invites':
      return 'wedding-invites';
    case 'Stickers & Labels':
      return 'stickers-labels';
    default:
      return 'visiting-cards';
  }
};

const PortfolioPage: React.FC = () => {
  const location = useLocation();

  const [activeCategory, setActiveCategory] = useState(() => {
    if (location.state && (location.state as any).category) {
      return (location.state as any).category;
    }
    const params = new URLSearchParams(location.search);
    const catParam = params.get('category');
    if (catParam && portfolioCategories.includes(catParam)) {
      return catParam;
    }
    return 'All';
  });

  useEffect(() => {
    if (location.state && (location.state as any).category) {
      setActiveCategory((location.state as any).category);
    } else {
      const params = new URLSearchParams(location.search);
      const catParam = params.get('category');
      if (catParam && portfolioCategories.includes(catParam)) {
        setActiveCategory(catParam);
      } else if (!location.state && !location.search) {
        setActiveCategory('All');
      }
    }
  }, [location]);

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  // Lightbox State
  const [selectedWork, setSelectedWork] = useState<PortfolioItem | null>(null);
  const [selectedWorkIndex, setSelectedWorkIndex] = useState<number | null>(null);

  // Feedback Form State
  const [feedbackForm, setFeedbackForm] = useState({ name: '', email: '', rating: 5, comment: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  // GraphQL — fetch approved reviews
  const { data: reviewsData, loading: reviewsLoading } = useQuery(GET_REVIEWS);
  const liveReviews = reviewsData?.reviews || [];

  // GraphQL — submit review mutation
  const [submitReviewMutation, { loading: reviewSubmitting }] = useMutation(SUBMIT_REVIEW);

  const filteredWorks = activeCategory === 'All'
    ? portfolioWorks
    : portfolioWorks.filter(item => item.category === activeCategory);

  const handleStarClick = (ratingValue: number) => {
    setFeedbackForm(prev => ({ ...prev, rating: ratingValue }));
  };

  // Navigation handlers for image gallery
  const openImageModal = (work: PortfolioItem) => {
    const index = filteredWorks.findIndex(item => item === work);
    setSelectedWork(work);
    setSelectedWorkIndex(index);
  };

  const goToPrevious = () => {
    if (selectedWorkIndex !== null && filteredWorks.length > 0) {
      const newIndex = (selectedWorkIndex - 1 + filteredWorks.length) % filteredWorks.length;
      setSelectedWork(filteredWorks[newIndex]);
      setSelectedWorkIndex(newIndex);
    }
  };

  const goToNext = () => {
    if (selectedWorkIndex !== null && filteredWorks.length > 0) {
      const newIndex = (selectedWorkIndex + 1) % filteredWorks.length;
      setSelectedWork(filteredWorks[newIndex]);
      setSelectedWorkIndex(newIndex);
    }
  };

  const closeModal = () => {
    setSelectedWork(null);
    setSelectedWorkIndex(null);
  };

  // Autoplay hook for the portfolio lightbox slider
  useEffect(() => {
    if (selectedWork === null || filteredWorks.length <= 1) return;
    const timer = setInterval(() => {
      goToNext();
    }, 4000);
    return () => clearInterval(timer);
  }, [selectedWork, selectedWorkIndex, filteredWorks]);

  const handleFeedbackChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFeedbackForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const submitFeedback = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!feedbackForm.name.trim() || !feedbackForm.email.trim() || !feedbackForm.comment.trim()) {
      setFormError('Please fill out all fields before submitting.');
      return;
    }
    setFormError('');
    try {
      const { data } = await submitReviewMutation({
        variables: {
          input: {
            name: feedbackForm.name,
            email: feedbackForm.email,
            rating: feedbackForm.rating,
            comment: feedbackForm.comment,
          },
        },
      });
      if (data?.submitReview?.success) {
        setFormSubmitted(true);
        setTimeout(() => {
          setFeedbackForm({ name: '', email: '', rating: 5, comment: '' });
          setFormSubmitted(false);
        }, 5000);
      } else {
        setFormError(data?.submitReview?.message || 'Submission failed. Please try again.');
      }
    } catch (err) {
      setFormError('Network error. Please check your connection and try again.');
    }
  };

  return (
    <div className="page-fade d-flex flex-column portfolio-page" style={{ minHeight: 'calc(100vh - 68px)', backgroundColor: '#fafbfe' }}>
      <div style={{ flex: 1 }}>
        <div className="breadcrumb-bar">
          <Link to="/">Home</Link> &gt; Portfolio
        </div>

        {/* Page Hero */}
        <div className="portfolio-hero text-center py-5" style={{ background: 'linear-gradient(135deg, #fff5fb 0%, #fdf2f8 50%, #ffffff 100%)', position: 'relative', overflow: 'hidden' }}>
          {/* Decorative background elements */}
          <div style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'rgba(233, 30, 140, 0.05)',
            zIndex: 0
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-80px',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'rgba(59, 91, 219, 0.05)',
            zIndex: 0
          }}></div>

          <Container style={{ position: 'relative', zIndex: 1 }}>
            <h2 className="display-5 fw-bold text-dark" style={{
              letterSpacing: '-0.5px',
              fontSize: 'clamp(28px, 6vw, 48px)',
              marginBottom: '20px',
              fontWeight: 700,
              background: 'linear-gradient(135deg, #1a1a1a 0%, #3b5bdb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Our <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Portfolio</span>
            </h2>
            <div className="section-underline mx-auto mb-4" style={{
              width: '70px',
              height: '4px',
              background: 'linear-gradient(90deg, #e91e8c 0%, #3b5bdb 100%)',
              borderRadius: '2px',
              boxShadow: '0 4px 12px rgba(233, 30, 140, 0.3)',
              margin: '0 auto 32px'
            }}></div>
            <p className="lead text-muted mx-auto mb-5" style={{
              maxWidth: '680px',
              fontSize: 'clamp(14px, 2.5vw, 16px)',
              lineHeight: '1.7',
              color: '#555555',
              fontWeight: 500
            }}>
              Explore our recent commercial printing jobs, bespoke invites, storefront branding displays, and labels tailored for local businesses.
            </p>
            <Link
              to={`/order?productId=${mapCategoryToProductId(activeCategory)}`}
              className="btn btn-primary-custom fw-bold text-white d-inline-flex align-items-center gap-2"
              style={{
                borderRadius: '10px',
                fontSize: 'clamp(13px, 2.5vw, 15px)',
                textDecoration: 'none',
                padding: '14px 28px',
                background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                border: 'none',
                boxShadow: '0 6px 20px rgba(233, 30, 140, 0.35)',
                transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                cursor: 'pointer',
                fontWeight: 700,
                letterSpacing: '0.3px'
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 28px rgba(233, 30, 140, 0.45)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 20px rgba(233, 30, 140, 0.35)';
              }}
            >
              <i className="fas fa-shopping-cart"></i> Go to Order Online
            </Link>
          </Container>
        </div>

        {/* Categories Tab Selector */}
        <Container className="my-5">
          <div className="portfolio-tabs-wrapper d-flex justify-content-center flex-wrap gap-3 py-4" style={{ background: 'linear-gradient(180deg, #ffffff 0%, rgba(255,255,255,0.5) 100%)', padding: '20px', borderRadius: '16px' }}>
            {portfolioCategories.map(cat => (
              <button
                key={cat}
                type="button"
                style={{
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  background: activeCategory === cat
                    ? 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)'
                    : '#f5f7fa',
                  color: activeCategory === cat ? '#fff' : '#666',
                  boxShadow: activeCategory === cat
                    ? '0 8px 20px rgba(233, 30, 140, 0.3)'
                    : '0 2px 8px rgba(0, 0, 0, 0.05)',
                  transform: 'translateY(0)',
                }}
                onMouseEnter={(e) => {
                  if (activeCategory !== cat) {
                    e.currentTarget.style.background = '#eeeff5';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeCategory !== cat) {
                    e.currentTarget.style.background = '#f5f7fa';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }
                }}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </Container>

        {/* Gallery Grid */}
        <Container className="pb-5">
          <Row className="g-4">
            {filteredWorks.map((work, idx) => (
              <Col key={work.title} xs={12} sm={6} md={4} lg={3}>
                <div
                  className="portfolio-work-card overflow-hidden h-100"
                  onClick={() => openImageModal(work)}
                  onMouseEnter={() => setHoveredIndex(idx)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    background: '#fff',
                    borderRadius: '14px',
                    border: '1px solid #eaeef5',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    transform: hoveredIndex === idx ? 'translateY(-12px) scale(1.02)' : 'translateY(0) scale(1)',
                    boxShadow: hoveredIndex === idx
                      ? '0 20px 40px rgba(233, 30, 140, 0.15)'
                      : '0 4px 15px rgba(0, 0, 0, 0.08)',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {/* Image Container */}
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      height: '220px',
                      background: 'linear-gradient(135deg, #f5f7fa 0%, #eaeef5 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={work.img}
                      alt={work.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        transform: hoveredIndex === idx ? 'scale(1.12)' : 'scale(1)',
                      }}
                    />

                    {/* Gradient Overlay */}
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: hoveredIndex === idx
                          ? 'linear-gradient(135deg, rgba(233, 30, 140, 0.2) 0%, rgba(59, 91, 219, 0.2) 100%)'
                          : 'linear-gradient(135deg, rgba(233, 30, 140, 0.05) 0%, rgba(59, 91, 219, 0.05) 100%)',
                        transition: 'all 0.4s ease',
                      }}
                    />

                    {/* Expand Icon */}
                    <div
                      style={{
                        position: 'absolute',
                        width: '50px',
                        height: '50px',
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
                        opacity: hoveredIndex === idx ? 1 : 0,
                        transform: hoveredIndex === idx ? 'scale(1)' : 'scale(0.8)',
                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      }}
                    >
                      <i className="fas fa-expand-alt" style={{ fontSize: '18px', color: '#e91e8c', fontWeight: '700' }}></i>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div style={{ padding: '18px', flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div>
                      <span
                        style={{
                          display: 'inline-block',
                          background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                          color: '#fff',
                          fontSize: '10px',
                          fontWeight: '700',
                          padding: '5px 12px',
                          borderRadius: '16px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          boxShadow: '0 4px 12px rgba(233, 30, 140, 0.2)',
                        }}
                      >
                        {work.category}
                      </span>
                    </div>
                    <div>
                      <h5 style={{
                        fontSize: '14px',
                        fontWeight: '700',
                        color: '#1a1a1a',
                        margin: '0',
                        lineHeight: '1.4',
                        textTransform: 'uppercase',
                        letterSpacing: '-0.3px',
                      }}>
                        {work.title}
                      </h5>
                      <p style={{
                        fontSize: '12px',
                        color: '#999',
                        margin: '4px 0 0 0',
                      }}>
                        Client: <span style={{ fontWeight: '600', color: '#666' }}>{work.client}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>

        {/* Lightbox Full Size Image Modal */}
        <Modal
          show={selectedWork !== null}
          onHide={closeModal}
          centered
          size="lg"
          contentClassName="bg-transparent border-0"
          keyboard={true}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'ArrowLeft') goToPrevious();
            if (e.key === 'ArrowRight') goToNext();
          }}
        >
          <Modal.Body className="p-0 position-relative text-center">
            <button
              type="button"
              className="btn btn-light btn-sm position-absolute top-0 end-0 m-3 rounded-circle shadow-lg d-flex align-items-center justify-content-center"
              onClick={closeModal}
              aria-label="Close"
              style={{
                zIndex: 1050,
                width: '40px',
                height: '40px',
                minWidth: '40px',
                padding: 0,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              }}
            >
              <i className="fas fa-times text-dark" style={{ fontSize: '16px' }}></i>
            </button>

            {/* Previous Arrow Button */}
            {selectedWorkIndex !== null && filteredWorks.length > 1 && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-3 rounded-circle d-flex align-items-center justify-content-center"
                onClick={goToPrevious}
                style={{ width: '48px', height: '48px', zIndex: 1050, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
                title="Previous (← arrow key)"
              >
                <i className="fas fa-chevron-left text-dark" style={{ fontSize: '20px' }}></i>
              </button>
            )}

            {selectedWork && (
              <div className="d-inline-block position-relative rounded-4 overflow-hidden bg-white p-2 shadow-lg">
                <img
                  src={selectedWork.img}
                  alt={selectedWork.title}
                  className="img-fluid rounded-3"
                  style={{ maxHeight: '80vh', objectFit: 'contain' }}
                />
                <div className="bg-white p-3 text-start d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <div>
                    <span className="badge bg-primary mb-2">{selectedWork.category}</span>
                    {selectedWorkIndex !== null && (
                      <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
                        Image {selectedWorkIndex + 1} of {filteredWorks.length}
                      </p>
                    )}
                  </div>
                  <Link
                    to={`/order?productId=${mapCategoryToProductId(selectedWork.category)}`}
                    className="btn btn-primary-custom px-4 py-2 fw-bold text-white d-flex align-items-center gap-2"
                    style={{ borderRadius: '8px', fontSize: '13.5px', textDecoration: 'none' }}
                  >
                    <i className="fas fa-shopping-cart"></i> Order Now
                  </Link>
                </div>
              </div>
            )}

            {/* Next Arrow Button */}
            {selectedWorkIndex !== null && filteredWorks.length > 1 && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-3 rounded-circle d-flex align-items-center justify-content-center"
                onClick={goToNext}
                style={{ width: '48px', height: '48px', zIndex: 1050, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
                title="Next (→ arrow key)"
              >
                <i className="fas fa-chevron-right text-dark" style={{ fontSize: '20px' }}></i>
              </button>
            )}
          </Modal.Body>
        </Modal>

        {/* Google Reviews Dashboard Showcase */}
        <div className="google-reviews-section py-5" style={{ backgroundColor: '#f4f6fa', borderTop: '1px solid #eaeef5', borderBottom: '1px solid #eaeef5' }}>
          <Container>
            <Row className="align-items-center mb-5">
              <Col md={6} className="text-start">
                <div className="d-flex align-items-center gap-3 mb-2">
                  <div className="google-logo-icon bg-white rounded-3 p-2 shadow-sm border d-inline-flex">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                      alt="Google Logo"
                      style={{ width: '28px', height: '28px' }}
                    />
                  </div>
                  <h3 className="fw-bold text-dark mb-0">Customer Reviews</h3>
                </div>
                <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                  See what our customers say about our print quality and turnaround speed on Google Reviews.
                </p>
              </Col>
              <Col md={6} className="text-md-end mt-3 mt-md-0">
                <div className="d-flex align-items-center justify-content-md-end gap-2">
                  <div className="fw-bold text-dark display-6 mb-0" style={{ fontSize: '36px' }}>4.9</div>
                  <div>
                    <div className="d-flex text-warning gap-1" style={{ fontSize: '16px' }}>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                    <div className="text-muted" style={{ fontSize: '11px' }}>Based on 142 verified reviews</div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="g-4">
              {reviewsLoading ? (
                <Col xs={12} className="text-center py-4 text-muted">
                  <i className="fas fa-spinner fa-spin me-2"></i>Loading reviews...
                </Col>
              ) : liveReviews.length === 0 ? (
                <Col xs={12} className="text-center py-4 text-muted">No reviews yet.</Col>
              ) : (
                liveReviews.map((review: any) => (
                  <Col key={review.id} xs={12} md={6}>
                    <Card className="review-card h-100 border-0 shadow-sm p-4 bg-white rounded-4 text-start">
                      <Card.Body className="p-0">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="avatar-circle rounded-circle text-white fw-bold d-flex align-items-center justify-content-center"
                              style={{
                                width: '38px',
                                height: '38px',
                                backgroundColor: review.avatarColor,
                                fontSize: '14px',
                              }}
                            >
                              {review.name.charAt(0)}
                            </div>
                            <div>
                              <h6 className="fw-bold text-dark mb-0" style={{ fontSize: '14px' }}>{review.name}</h6>
                              <span className="text-muted" style={{ fontSize: '11px' }}>
                                {new Date(review.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                              </span>
                            </div>
                          </div>
                          <div className="d-flex text-warning" style={{ fontSize: '12px', gap: '2px' }}>
                            {Array.from({ length: review.rating }).map((_: any, i: number) => (
                              <i key={i} className="fas fa-star"></i>
                            ))}
                          </div>
                        </div>
                        <p className="text-muted mb-0" style={{ fontSize: '13px', lineHeight: '1.6' }}>
                          "{review.comment}"
                        </p>
                        <div className="d-flex align-items-center gap-1 mt-3" style={{ fontSize: '11px', color: '#4caf50' }}>
                          <i className="fas fa-check-circle"></i>
                          <span>Verified Customer</span>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              )}
            </Row>
          </Container>
        </div>

        {/* Feedback Option Submission */}
        <Container className="py-5">
          <div className="feedback-form-wrapper bg-white shadow-sm border rounded-4 p-4 p-md-5 mx-auto" style={{ maxWidth: '650px' }}>
            <div className="text-center mb-4">
              <h4 className="fw-bold text-dark">Share Your Experience</h4>
              <p className="text-muted" style={{ fontSize: '13px' }}>
                Had prints done with us? We appreciate your valuable feedback! Let us know how we did.
              </p>
            </div>

            {formSubmitted ? (
              <div className="text-center py-4 step-content-fade">
                <i className="fas fa-check-circle text-success mb-3" style={{ fontSize: '52px' }}></i>
                <h5 className="fw-bold text-dark mb-1">Feedback Submitted Successfully!</h5>
                <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                  Thank you! Your testimonial helps us improve our customer service and print quality.
                </p>
              </div>
            ) : (
              <form onSubmit={submitFeedback}>
                {formError && (
                  <div className="alert alert-danger py-2 px-3 mb-3 border-0 rounded-3 text-start" style={{ fontSize: '12px' }}>
                    {formError}
                  </div>
                )}

                {/* Rating Stars Selector */}
                <div className="mb-4 text-center">
                  <label className="d-block text-dark fw-bold mb-2" style={{ fontSize: '14px' }}>Your Overall Rating</label>
                  <div className="d-inline-flex gap-2">
                    {[1, 2, 3, 4, 5].map(star => {
                      const isActive = feedbackForm.rating >= star;
                      return (
                        <button
                          key={star}
                          type="button"
                          onClick={() => handleStarClick(star)}
                          className="btn p-0 border-0"
                          style={{
                            fontSize: '26px',
                            color: isActive ? '#ffca28' : '#e0e0e0',
                            transition: 'color 0.2s',
                            cursor: 'pointer',
                          }}
                        >
                          <i className={`fas fa-star`}></i>
                        </button>
                      );
                    })}
                  </div>
                </div>

                <div className="row g-3 text-start">
                  <Col md={6}>
                    <div className="mb-2">
                      <label className="form-label text-dark fw-semibold" style={{ fontSize: '13px' }}>Full Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-input py-2"
                        placeholder="John Doe"
                        value={feedbackForm.name}
                        onChange={handleFeedbackChange}
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-2">
                      <label className="form-label text-dark fw-semibold" style={{ fontSize: '13px' }}>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        className="form-input py-2"
                        placeholder="john@example.com"
                        value={feedbackForm.email}
                        onChange={handleFeedbackChange}
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <div className="mb-3">
                      <label className="form-label text-dark fw-semibold" style={{ fontSize: '13px' }}>Feedback Details</label>
                      <textarea
                        name="comment"
                        className="form-input"
                        placeholder="Describe the print products you ordered and your satisfaction with the quality, timeline, and support..."
                        style={{ height: '90px' }}
                        value={feedbackForm.comment}
                        onChange={handleFeedbackChange}
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <button
                      type="submit"
                      className="btn-primary-custom w-100 py-3 fw-bold"
                      style={{ borderRadius: '8px' }}
                      disabled={reviewSubmitting}
                    >
                      {reviewSubmitting ? (
                        <><i className="fas fa-spinner fa-spin me-2"></i>Submitting...</>
                      ) : 'Submit Feedback Review'}
                    </button>
                  </Col>
                </div>
              </form>
            )}
          </div>
        </Container>

      </div>

      <UspStrip />
      <Footer />
    </div>
  );
};

export default PortfolioPage;
